import { format } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import { parse } from 'date-fns/parse';
import zod from 'zod';

import { t } from '../../core/logical/type-presets.js';
import { propertyType } from '../../core/property/property-config.js';
export const datePropertyType = propertyType('date');

export type DatePropertyData = {
  includeTime?: boolean;
  timezoneMode?: 'workspace' | 'user' | 'explicit';
};

const DATE_ONLY_FORMAT = 'yyyy-MM-dd';
const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';

export const datePropertyModelConfig = datePropertyType.modelConfig({
  name: 'Date',
  propertyData: {
    schema: zod.object({
      includeTime: zod.boolean().optional(),
      timezoneMode: zod.enum(['workspace', 'user', 'explicit']).optional(),
    }),
    default: (): DatePropertyData => ({}),
  },
  jsonValue: {
    schema: zod.number().nullable(),
    isEmpty: () => false,
    type: () => t.date.instance(),
  },
  rawValue: {
    schema: zod.number().nullable(),
    default: () => null,
    toString: ({ value, data }) =>
      value != null
        ? format(value, data.includeTime ? DATE_TIME_FORMAT : DATE_ONLY_FORMAT)
        : '',
    fromString: ({ value }) => {
      const trimmed = value.trim();
      const date = parse(
        trimmed,
        trimmed.includes(':') ? DATE_TIME_FORMAT : DATE_ONLY_FORMAT,
        new Date()
      );
      if (!isValid(date)) {
        return { value: null };
      }
      return { value: +date };
    },
    toJson: ({ value }) => value,
    fromJson: ({ value }) => value,
  },
});
